import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import { defaultFontNormal } from "../utils/styling";

export const getConsentingNonConsentingCompaniesParagraphs = (data) => {
  const { nonConsentingCompaniesExist } = data;

  const paragraphs = [
    {
      condition: true,
      segments: [
        {
          text: "The list of consenting and non-consenting companies is set out in Appendix 1. The consenting company provisions are intended to protect minority interest holders by limiting the amount of any interest disallowance that can be allocated to a non-consenting company to its pro-rata share (based on Tax-Interest expense amounts).",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: true,
      segments: [
        {
          text: "In contrast, where a company has notified both the group reporting company and HMRC that it intends to be a consenting company prior to the submission of a CIR return, the group reporting company can freely allocate a disallowance to this company. Any such notification can also be revoked by the consenting company.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      condition: nonConsentingCompaniesExist,
      segments: [
        {
          text: "Please let us know if you would like any of the non-consenting companies in Appendix 1 to become consenting companies prior to submission of the CIR return.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Consenting / Non-Consenting Companies"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
